module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Special items":"Special items"},"fr":{"Special items":"Objets spéciaux"}}')
  delete Component.options._Ctor
}
